import { render, staticRenderFns } from "./BuildingOrderStats.vue?vue&type=template&id=73957c8f&scoped=true&"
import script from "./BuildingOrderStats.vue?vue&type=script&lang=js&"
export * from "./BuildingOrderStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73957c8f",
  null
  
)

export default component.exports